<template>
  <div>
    <div class="section1 safe-area">
      <pageTitle cn="高规格外事接待" en="High-level Official Reception" type="1"></pageTitle>
      <div class="common-title-d1 mt-20">全部海内外研学项目获得中外两国政府、教育文化部门双重官方支持；目的国驻华大使馆开通签证绿色通道；抵达、研学交流、收官颁奖全流程有中外官方官员出席接待。</div>
      <div class="common-title-d2 mt-12">All study tour programs, both domestic and international, receive dual official support from the governments and education and cultural departments of both China and the host countries; the host countries’ embassies in China have established a visa fast-track process; and officials from both China and the host countries are present to welcome participants throughout the entire process—from arrival and study exchanges to the closing ceremony and awards presentation.</div>
      <img class="mt-20" :src="$env.imgUrl + 'explore3-s1.png'" alt="">
    </div>
    <div class="section2" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area page-flex-lr-center">
        <div class="lf">
          <pageTitle cn="双语荣誉证书" en="Bilingual Official Certificates" type="2"></pageTitle>
          <div class="common-title-d3 mt-20">研学收官举办专属官方颁奖仪式，当地政府官员现场颁发双语研学奖杯、联合国认证实践证书；全套行程方案经当地教育、文旅部门审定，全程配备专业导师与安全保障团队。</div>
          <div class="common-title-d4 mt-12">To mark the conclusion of the study tour, an exclusive official awards ceremony was held, where local government officials presented bilingual study tour trophies and UN-certified participation certificates on-site. The entire itinerary was approved by local education and culture and tourism departments, and the program was supported by professional mentors and a safety team throughout.</div>
        </div>
        <div class="rt">
          <img :src="$env.imgUrl + 'explore3-s2.png'" alt="">
        </div>
      </div>
    </div>
    <div class="section3">
      <div class="safe-area">
        <pageTitle cn="探究四大亮点" en="Four Key Highlights" type="1"></pageTitle>
        <div class="page-flex-lr-center-between mt-20">
          <img :src="$env.imgUrl + 'explore3-s3-1.png'" alt="">
          <img :src="$env.imgUrl + 'explore3-s3-2.png'" alt="">
        </div>
        <div class="page-flex-lr-center-between mt-20">
          <img :src="$env.imgUrl + 'explore3-s3-3.png'" alt="">
          <img :src="$env.imgUrl + 'explore3-s3-4.png'" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style scoped lang="less">
.mt-20{
  margin-top: 20px;
}
.section1{
  padding: 30px 0 40px;
  img{
    width: 100%;
  }
}
.section2{
  padding: 80px 0;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .lf{
    width: 55%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
    img{
      width: 100%;
    }
  }
}
.section3 {
  padding: 20px 0 60px;
  img{
    width: 49%;
  }
}
</style>
